var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "hide-footer": "",
        "title-class": "sip-modal-title",
        "body-class": "sip-photo-drawer-body p-0",
        "dialog-class": "sip-photo-drawer-dialog",
      },
      on: { show: _vm.onModalShow, hidden: _vm.onModalHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "div",
                  { staticClass: "sip-photo-drawer-header-icon me-2" },
                  [_c("i", { staticClass: "fi fi-rr-camera text-primary" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "sip-photo-drawer-header-title" }, [
                  _vm._v(_vm._s(_vm.modalTitle)),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "sip-photo-drawer-content" }, [
        _c("div", { staticClass: "sip-photo-drawer-scroll-body" }, [
          !_vm.selectedFile
            ? _c(
                "div",
                {
                  staticClass: "sip-photo-dropzone-box",
                  class: { "is-dragover": _vm.isDragOver },
                  on: {
                    dragenter: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragEnter.apply(null, arguments)
                    },
                    dragover: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragEnter.apply(null, arguments)
                    },
                    dragleave: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragLeave.apply(null, arguments)
                    },
                    drop: function ($event) {
                      $event.preventDefault()
                      return _vm.onDrop.apply(null, arguments)
                    },
                    click: _vm.triggerFileInput,
                  },
                },
                [
                  _c("input", {
                    ref: "fileInput",
                    staticClass: "sip-photo-hidden-input",
                    attrs: {
                      type: "file",
                      accept:
                        ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp",
                    },
                    on: { change: _vm.onFileChange },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "sip-photo-dropzone-icon-circle" }, [
                    _c("i", { staticClass: "fi fi-rr-cloud-upload" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sip-photo-dropzone-text" }, [
                    _c(
                      "span",
                      { staticClass: "sip-photo-dropzone-primary-text" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.trans("student.drop_photo_here") ||
                                "Drag & drop or"
                            ) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "sip-photo-browse-link" }, [
                          _vm._v(
                            _vm._s(_vm.trans("general.browse") || "Browse")
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "sip-photo-dropzone-subtext text-muted" },
                      [
                        _vm._v(
                          "\n                        JPG, PNG · Max " +
                            _vm._s(_vm.maxSizeMb) +
                            "MB\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _c("div", { staticClass: "sip-photo-preview-card" }, [
                _c("div", { staticClass: "sip-photo-preview-body" }, [
                  _c("div", { staticClass: "sip-photo-preview-thumb-wrap" }, [
                    _c("img", {
                      staticClass: "sip-photo-preview-thumb",
                      attrs: {
                        src: _vm.selectedFilePreview,
                        alt: "Selected Preview",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sip-photo-preview-meta" }, [
                    _c(
                      "div",
                      {
                        staticClass: "sip-photo-preview-filename",
                        attrs: { title: _vm.selectedFile.name },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.selectedFile.name) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sip-photo-preview-filesize text-muted small",
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.formatFileSize(_vm.selectedFile.size)) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sip-photo-preview-actions mt-2" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs btn-outline-primary",
                            attrs: {
                              type: "button",
                              disabled: _vm.isUploading,
                            },
                            on: { click: _vm.triggerFileInput },
                          },
                          [
                            _c("i", { staticClass: "fi fi-rr-refresh me-1" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.trans("general.change_file") || "Change"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs btn-outline-secondary",
                            attrs: {
                              type: "button",
                              disabled: _vm.isUploading,
                            },
                            on: { click: _vm.clearSelectedFile },
                          },
                          [
                            _c("i", { staticClass: "fi fi-rr-cross me-1" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.trans("general.clear") || "Clear") +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          ref: "fileInput",
                          staticClass: "sip-photo-hidden-input",
                          attrs: {
                            type: "file",
                            accept:
                              ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp",
                          },
                          on: { change: _vm.onFileChange },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]),
          _vm._v(" "),
          _vm.hasCustomPhoto && !_vm.selectedFile
            ? _c("div", { staticClass: "sip-photo-remove-link-wrap" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "confirm",
                        rawName: "v-confirm",
                        value: { ok: _vm.confirmRemovePhoto() },
                        expression: "{ok: confirmRemovePhoto()}",
                      },
                    ],
                    staticClass: "sip-photo-remove-link",
                    attrs: {
                      type: "button",
                      disabled: _vm.isUploading || _vm.isRemoving,
                    },
                  },
                  [
                    _vm.isRemoving
                      ? _c("span", {
                          staticClass: "spinner-border spinner-border-sm me-1",
                          attrs: { role: "status" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.isRemoving
                            ? _vm.trans("general.processing") || "Removing..."
                            : _vm.trans("student.remove_photo") ||
                                "Remove current photo"
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sip-drawer-form-footer modal-footer w-100" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-light sip-drawer-btn-cancel",
                attrs: {
                  type: "button",
                  disabled: _vm.isUploading || _vm.isRemoving,
                },
                on: { click: _vm.closeModal },
              },
              [
                _c("em", { staticClass: "icon ni ni-cross" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.trans("general.cancel") || "Cancel")),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary sip-drawer-btn-save",
                attrs: {
                  type: "button",
                  disabled:
                    !_vm.selectedFile || _vm.isUploading || _vm.isRemoving,
                },
                on: { click: _vm.uploadPhoto },
              },
              [
                _vm.isUploading
                  ? _c("span", {
                      staticClass: "spinner-border spinner-border-sm me-1",
                      attrs: { role: "status", "aria-hidden": "true" },
                    })
                  : _c("em", { staticClass: "icon ni ni-upload-cloud me-1" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.isUploading
                        ? _vm.trans("general.uploading") || "Uploading..."
                        : _vm.trans("student.upload_and_save") ||
                            "Upload & Save"
                    )
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }